
import './Header.css';
import React from "react";

function Header(props) {
    return (
        <div className="header">
        </div>
    )
}

export default Header;